var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"google-map-style-1"},[_c('iframe',{staticStyle:{"border":"0"},attrs:{"src":"https://maps.google.com/maps?width=600&height=400&hl=en&q=Intellectworks Digital Solutions&t=&z=14&ie=UTF8&iwloc=B&output=embed","width":"600","height":"550","allowfullscreen":"","loading":"lazy"}})])
}]

export { render, staticRenderFns }